import Confetti from "react-confetti";
import styled from "styled-components";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";

import coinsIcon from "assets/img/icons/coins-icon.svg";
import bulbIcon from "assets/img/icons/tip-bulb.svg";

const Discover = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;

  margin: 0;
  padding: 0;

  display: flex;
  flex-direction: column;

  opacity: ${(props) => (props.display ? 100 : 0)};

  transition: 0.2s;
`;

const PostBox = styled.div`
  position: relative;
  width: 100%;
  padding: 10px 10px 15px;
  box-sizing: border-box;
  margin-top: 8px;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: 10px;

  overflow: hidden;

  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Reward = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

const RewardNote = styled.div`
  width: 100%;
  height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
`;

const RewardBox = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const RewardIconCircle = styled.div`
  width: 90px;
  min-width: 90px;
  height: 90px;

  border-radius: 50%;
  background: ${css.FLAT_BOX_BACKGROUND};

  display: flex;
  justify-content: center;
  align-items: center;
`;

const RewardIcon = styled.div`
  width: 35px;
  min-width: 35px;
  height: 35px;
`;

const RewardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const RewardTitle = styled.div`
  font-size: 24px;
  font-weight: 500;
`;

const RewardSubTitle = styled.div`
  font-size: 12px;
  color: ${css.BRAND_GREEN};
  text-align: center;
`;

const RewardNoteIcon = styled.div`
  width: 15px;
  min-width: 15px;
  height: 15px;
`;

const RewardNoteText = styled.div`
  font-size: 10px;
`;

const BottomContent = styled.div`
  position: relative;
  margin-top: ${css.VERTICAL_BOX_MARGIN_MEDIUM};

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const NextButtonWrap = styled.div``;

const ButtonBig = styled.div`
  box-sizing: border-box;
  height: 40px;
  padding: 0 17px;

  background: ${(props) =>
    props.disabled ? css.BRAND_BLUSH : css.BRAND_YELLOW};
  border-radius: 30px;
  border: 0;

  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 11px;
  color: ${css.DARK_BLUE};
  white-space: nowrap;

  transition: 0.2s;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export default ({ display }) => {
  return (
    <Discover display={display}>
      <PostBox>
        <Reward>
          <RewardNote />
          <RewardBox>
            <RewardIconCircle>
              <RewardIcon>
                <img src={coinsIcon} alr="Reward" style={{ width: "100%" }} />
              </RewardIcon>
            </RewardIconCircle>
            <RewardContent>
              <RewardTitle>You found coins!</RewardTitle>
              <RewardSubTitle>
                358 coins have been added to your wallet
              </RewardSubTitle>
            </RewardContent>
          </RewardBox>
          <RewardNote>
            <RewardNoteIcon>
              <img src={bulbIcon} alt="Tip" style={{ width: "100%" }} />
            </RewardNoteIcon>
            <RewardNoteText>
              Continue browsing to get even more coins.
            </RewardNoteText>
          </RewardNote>
          <Confetti />
        </Reward>
      </PostBox>
      <BottomContent>
        <NextButtonWrap id="nextButton">
          <ButtonBig>Show Next Post</ButtonBig>
        </NextButtonWrap>
      </BottomContent>
    </Discover>
  );
};
